import { RefObject, useEffect } from 'react';

const useClickAway = (ref: RefObject<any>, callback?: (event: any) => void): void => {
    function handleClickOutside(event?: any) {
        if (event.which === 1 && ref.current && !ref.current.contains(event.target)) {
            if (typeof callback === 'function') {
                callback(event);
            }
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside.bind(this));

        return () => {
            document.removeEventListener('mousedown', handleClickOutside.bind(this));
        };
    }, []);
};

export default useClickAway;
